import { Building2 } from "lucide-react";
import { ManualeLayout, Scheda, P, Steps, Bullets, Callout, FAQ } from "@/pages/manuali/ManualeLayout";

const A = "#7C3AED";
const SEZIONI = [
  { id: "intro", titolo: "Cos'è e come si avvia" },
  { id: "attend", titolo: "Livelli di attendibilità" },
  { id: "catnat", titolo: "Rischio catastrofale (CAT NAT)" },
  { id: "report", titolo: "Relazione / Report PDF" },
  { id: "pratiche", titolo: "Precompilazione pratiche" },
  { id: "questionario", titolo: "Questionario al cliente" },
  { id: "terzi", titolo: "Portale Terzi" },
  { id: "legale", titolo: "Limiti e note legali" },
  { id: "faq", titolo: "Domande frequenti" },
];

export default function ManualeBusinessIntelligence() {
  return (
    <ManualeLayout titolo="Business Intelligence" sottotitolo="Pre-analisi assicurativa delle aziende su fonti pubbliche gratuite" icona={Building2} accent={A} sezioni={SEZIONI}>
      <Scheda id="intro" n={1} titolo="Cos'è e come si avvia un'analisi" accent={A}>
        <P>Inserisci un solo dato — <b>Partita IVA</b>, <b>Codice Fiscale</b> o <b>Ragione Sociale</b> — e avvia l'analisi. Il sistema costruisce un <b>dossier</b> aggregando fonti pubbliche gratuite (VIES, IndicePA, ISTAT ATECO, sito/web via AI) e, in modalità Assicurativa, un profilo di rischio con i prodotti del catalogo d'agenzia.</P>
        <P>Usa "Aggiorna dati" per rieseguire le fonti; l'analisi resta nella cronologia.</P>
      </Scheda>

      <Scheda id="attend" n={2} titolo="Livelli di attendibilità del dato" accent={A}>
        <Bullets items={[
          "Verificato — da fonte ufficiale (VIES, IndicePA, ISTAT, Protezione Civile).",
          "Dichiarato — da fonte aziendale/autodichiarata (es. sito).",
          "Inferenza — elaborazione automatica/AI su dati pubblici, da verificare.",
        ]} />
        <Callout tipo="info">Solo i dati "Verificati" provengono da registri ufficiali: è la distinzione chiave per una lettura seria del dossier.</Callout>
      </Scheda>

      <Scheda id="catnat" n={3} titolo="Rischio catastrofale (CAT NAT)" accent={A}>
        <Bullets items={[
          "Rischio sismico: dato UFFICIALE per comune (classificazione sismica nazionale della Protezione Civile), zona 1–4.",
          "Rischio alluvione: stima prudente, da verificare sulle mappe ufficiali ISPRA/IdroGEO (link diretto nella scheda).",
        ]} />
      </Scheda>

      <Scheda id="report" n={4} titolo="Relazione / Report PDF a due livelli" accent={A}>
        <P>Il report è diviso in due parti chiaramente etichettate:</P>
        <Bullets items={[
          "Parte 1 — Dati verificati: solo informazioni da fonti ufficiali.",
          "Parte 2 — Valutazioni e ipotesi: elaborazioni AI/open-web, esposizioni e domande al cliente.",
        ]} />
        <P>Puoi scegliere il modello di scrittura: <b>GPT-5.4</b> o <b>Claude Sonnet 4.6</b>. La relazione si basa solo sui dati raccolti e non inventa: dove un dato manca indica "informazione non disponibile".</P>
      </Scheda>

      <Scheda id="pratiche" n={5} titolo="Precompilazione pratiche" accent={A}>
        <P>Dal dossier puoi generare una <b>bozza precompilata</b> di pratica <b>Cauzioni</b> o <b>MUP</b> con i dati anagrafici già valorizzati, da completare nel rispettivo modulo.</P>
      </Scheda>

      <Scheda id="questionario" n={6} titolo="Questionario al cliente" accent={A}>
        <P>In modalità Assicurativa puoi creare un <b>link pubblico</b> con le domande pre-assuntive: il cliente lo compila senza accedere alla Suite e le risposte rientrano automaticamente nell'analisi.</P>
      </Scheda>

      <Scheda id="terzi" n={7} titolo="Portale Terzi (accesso esterno)" accent={A}>
        <P>La card ha una gestione <b>accessi Terzi</b> riservata all'amministratore della card. Da "Gestione accessi Terzi":</P>
        <Steps items={[
          "Crei utenze esterne (username + password), con etichetta e quota mensile opzionale.",
          "Puoi resettare la password, disattivare o eliminare un'utenza.",
        ]} />
        <P>I Terzi accedono al <b>portale dedicato</b> all'indirizzo <b>/bi-portal</b> con le credenziali ricevute, senza essere registrati sulla Suite e senza vedere alcun dato d'agenzia (il catalogo prodotti non viene mostrato). Possono cercare un'azienda, vedere il dossier e scaricare il report PDF.</P>
      </Scheda>

      <Scheda id="legale" n={8} titolo="Limiti e note legali" accent={A}>
        <Callout tipo="warn">Il dossier aggrega informazioni pubblicamente disponibili e stime automatiche: <b>non</b> costituisce visura ufficiale, rating creditizio, valutazione di solvibilità né consulenza. I dati vanno verificati alle fonti ufficiali. Le fonti a pagamento (Registro Imprese, rating, ricerca web certificata) non sono attive in questa versione. Trattamento dati conforme al GDPR.</Callout>
      </Scheda>

      <Scheda id="faq" n={9} titolo="Domande frequenti" accent={A}>
        <FAQ items={[
          { q: "Il report inventa dati?", a: "No: è impostato per usare solo i dati raccolti e indicare 'non disponibile' dove manca l'informazione." },
          { q: "Posso vendere l'accesso a Terzi?", a: "Sì, tramite il Portale Terzi con utenze dedicate; la monetizzazione a canone si potrà attivare in futuro." },
          { q: "Come salvo questo manuale in PDF?", a: "Usa 'Stampa / Salva PDF' in alto a destra." },
        ]} />
      </Scheda>
    </ManualeLayout>
  );
}
